function isDigitKey(key) {
  const digitRegex = /[0-9|\b|]/;
  return digitRegex.test(key);
}

function isControlKey(key) {
  const allowedKeys = ['arrowup', 'arrowdown', 'arrowleft', 'arrowright', 'tab', 'backspace', 'delete'];
  return allowedKeys.indexOf(key.toLowerCase()) > -1;
}

const creditCardNumberValidate = {
  addListener: () => {
    const creditNumInput = document.querySelector('#credit-card-num');
    if (creditNumInput) {
      creditNumInput.addEventListener('keydown', ev => creditCardNumberValidate.validKeyPress(ev));
    }
  },

  validKeyPress: (ev) => {
    if (!ev || !ev.key) return false;

    if (isControlKey(ev.key) || isDigitKey(ev.key)) return true;

    ev.preventDefault();
  },
};

module.exports = creditCardNumberValidate;
